import familyService from '@/apis/family/service';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import useQueries from '@/hooks/useQueries';
import FamilyTable from '@/screens/Family/components/FamilyTable';
import TitleFamily from '@/screens/Family/components/TitleFamily';
import { Form, Input } from 'antd';
import { debounce } from 'lodash';
import * as React from 'react';

interface SearchHandlerParams {
  search?: string;
  page?: number;
  limit?: number;
}

export interface IFamilyProps {}

function ImpFamily(props: IFamilyProps) {
  const [queries, setQueries] = useQueries();
  const { search = '', page = 1, limit = 20 } = queries;

  const { data } = familyService.useGetFamilies({ limit, page, search });

  const records = data?.data;
  const total = data?.meta?.total;

  const searchHandler = React.useCallback(
    async function (val: SearchHandlerParams | Function) {
      const newCondition = val;
      setQueries(newCondition);
    },
    [setQueries],
  );

  const debounceHandler = React.useMemo(
    () =>
      debounce(
        (values: { search: string }) => {
          if (values.search?.length > 2 || !values.search) {
            searchHandler({ search: values.search });
          }
        },
        500,
        { leading: false },
      ),
    [searchHandler],
  );
  return (
    <div className="bg-white h-full p-4 flex flex-col w-full">
      <div className="pb-4">
        <TitleFamily />
        <Form initialValues={{ search: search }} onValuesChange={(values) => debounceHandler(values)}>
          <Form.Item name={'search'}>
            <Input
              name="search"
              addonBefore={<BaseIconSvg src="/icons/Regular/Search - icon.svg" />}
              placeholder="Tìm kiếm theo mã gia đình tên/số điện thoại của thành viên"
            />
          </Form.Item>
        </Form>
      </div>
      <div className="flex-grow w-full">
        <FamilyTable data={records} total={total} searchHandler={searchHandler} />
      </div>
    </div>
  );
}

export default function Family(props: IFamilyProps) {
  return <ImpFamily {...props} />;
}
